
import SearchForm from "@/components/SearchForm.vue";
import Products from "@/components/Products.vue";
import { Component, Prop, Vue } from "vue-property-decorator";
import Ugcs from "@/components/Ugcs.vue";

@Component({
  components: { SearchForm, Products, Ugcs },
})
export default class SearchProducts extends Vue {
  @Prop()
  tab!: string;
  @Prop()
  keyword!: string;

  currentTab = ""; // 현재 탭

  // methods

  // initialized events
  created(): void {
    switch (this.$route.name) {
      // TODO 피드오픈하면 김태혁
      case "SearchUgcs" :
        this.currentTab = "review";
        break;
      default :
        this.currentTab = this.tab || "product";
        break;
    }
  }
}
